import { useEffect, useState } from 'react';
import HttpService from '../services/HttpService';
const getSetSelfDetails = async () => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/user`);
  return response.data;
};

const getBasicUserDetails = async () => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/basic`);
  return response.data;
};


export const useUserDbInfo = () => {
  const [userDbInfo, setUserDbInfo] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserDbInfo = async () => {
      const userDbInfo = await getSetSelfDetails();
      setUserDbInfo(userDbInfo);
      setLoading(false);
    };
    getUserDbInfo();
  }, []);

  return { userDbInfo, loading };
};

export const basicUserDbInfo = () => {
  const [basicUserInfo, setBasicUserInfo] = useState<any>(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const getBasicUserDbInfo = async () => {
      const basicUserInfo = await getBasicUserDetails();
      setBasicUserInfo(basicUserInfo);
      setLoading(false);
    };
    getBasicUserDbInfo();
  }, []);


  return { basicUserInfo, loading };


};